<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col cols="12" class="d-flex justify-end">
        <ButtonComp @click="showExportData" icon-but="fas fa-file" class-color="success"
          text-button="Generar Deuda al Banco" normal-button />
      </v-col>
      <v-col cols="12">
        <ComundataTablecomp :headers="DeudasBancosHeaders" :items="listItems" :search="search" whit-search whitSelect
          itemkey="id_asig_movimiento_pago" v-model="selectedItems" :loading="loading">
          <template v-slot>
            <AutocompleteComp text-label="Banco" v-model="filtro.id_banco" :items="lista_filtro_bancos"
              @change="changeFiltroBanco()" item-value="id_banco" item-text="nombre_banco" />
          </template>
          <template v-slot:fecha_vencimiento="{ item }">{{ item.fecha_vencimiento | filtroFecha }}</template>
        </ComundataTablecomp>
      </v-col>
    </v-row>

    <!-- consultar -->

  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import CommonRules from "../../commonRules";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { DeudasBancosHeaders } from '../../../../helpers/headersTable';
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import AutocompleteComp from "../../../../components/ComponentsEst/AutocompleteComp.vue";
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';

export default {
  components: {
    AutocompleteComp,
    ComundataTablecomp,
    ButtonComp
  },
  data: () => ({
    paramComponente: { id_submodulo: 2, id_modulo: 4 },
    dataSession: sessionStorage,
    DeudasBancosHeaders,
    selectedItems: [],
    showDialog: false,
    btnIsSaving: false,
    loading: false,
    filtro: {
      id_banco: null
    },
    search: "",
    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    rul: CommonRules(),
    listItems: [],
    lista_filtro_bancos: [],
    isNew: true,
  }),

  computed: {
    formTitle() {
      return this.isNew ? "Registro de Deuda" : "Editar Registro de Deuda";
    },

    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    this.getListaAsigDeudaBancos();
    this.getListaBancosFiltro();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    async changeFiltroBanco() {
      await this.getListaAsigDeudaBancos();
    },

    /// FILTROS
    getListaBancosFiltro() {
      axios
        .get("/tesoreria/common/banco")
        .then((response) => {
          this.lista_filtro_bancos = response.data;
          console.log(this.lista_filtro_bancos);
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
          //console.log(e);
        });
    },


    async getListaAsigDeudaBancos() {
      console.log(this.dataSession);
      this.selectedItems = [];
      this.loading = true;
      this.filtro.id_anio = this.dataSession.id_ano_lectivo;
      this.filtro.id_colegio = this.dataSession.id_colegio;
      await axios
        .post("/tesoreria/asignacion/deuda_banco/consulta", this.filtro)
        .then((response) => {
          this.listItems = response.data;
          this.loading = false;
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
          this.loading = false;
        });
    },

    async showExportData() {
      try {
        const params = this.filtro;
        const banco = this.lista_filtro_bancos.filter(x => x.id_banco == params.id_banco);
        params.nombre_banco = banco.length > 0 ? banco[0]['nombre_banco'] : '';
        params.id_anio = this.dataSession.id_ano_lectivo;
        params.id_colegio = this.dataSession.id_colegio;

        let response = await axios.post("/tesoreria/report/consulta/rpt_deudas_banco_pendientes", params);
        if (response.data.error == 1) {
          this.setEnviarMens({ tipo: "E", mensaje: `${response.data.message}`, tiempo: null });
        }
        else {
          let archivoADescargar = '';
          let dataResponse = response.data
          this.setEnviarMens({ tipo: dataResponse.messageT, mensaje: dataResponse.message, tiempo: 3000 })
          this.generandoReporte = 0
          if (dataResponse.messageT == 'S') {
            archivoADescargar = dataResponse.fileToDownload;
            axios({
              url: '/tesoreria/report/bajarReporte/' + dataResponse.nameReport,
              method: 'GET',
              responseType: 'blob',
            }).then((response) => {
              this.setEnviarMens({ tipo: 'S', mensaje: 'Generando reporte', tiempo: 3000 })

              const url = window.URL.createObjectURL(new Blob([response.data]));
              console.log(response.data)
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', archivoADescargar);
              document.body.appendChild(link);
              link.click();
              link.remove()
              window.URL.revokeObjectURL(url);
            });
          }
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
  },
};
</script>